export const PROCESSED_URL_PATH = '/api/file/image';
export const VIDEO_PROCESSED_URL_PATH = '/api/file/video';
export const CONTENT_TYPES = {
  PNG: 'image/png',
  MP4: 'video/mp4',
};
